import { AbstractModel } from '../models/AbstractModel'
import { Rally } from './Rally'

export class RallyLink extends AbstractModel {
    id = 0
    rallyId = -1
    rally: Rally = new Rally()
    heading = ''
    linkText = ''
    newsletter = false
    newsletterType = ''
    link = ''
    active = true
    createdAt = ''
    updatedAt = ''
}
